import { useMsal } from '@azure/msal-react';
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useNavigate } from 'react-router';
import { useCommonStyles, useStores } from '../../../common/hooks';
import { RoutePaths } from '../../../route-paths';

interface NoCountrySelectionModalProps {
  isModalOpen: boolean;
  onDismissModal: () => void;
}

const NoCountrySelectionModalImpl: React.FC<NoCountrySelectionModalProps> = (props) => {
  const {
    isModalOpen,
    onDismissModal,
  } = props;

  const { 
    instance,
  } = useMsal();

  const navigate = useNavigate();

  const {
    apiStore,
    reviewAndSubmitNominationPageUiStore,
  } = useStores();

  const commonStyles = useCommonStyles();

  const redirectToNominationWizardStep = async (furthestNominationStepCode: string, latestVisitedNominationStepCode: string): Promise<void> => {
    if (!reviewAndSubmitNominationPageUiStore.currentNomination) return;

    try {
      await apiStore.updateNominationProgress(
        instance,
        reviewAndSubmitNominationPageUiStore.currentNomination.nominationId,
        {
          furthestNominationStepCode: furthestNominationStepCode,
          latestVisitedNominationStepCode: latestVisitedNominationStepCode,
        });

      navigate(
        `${RoutePaths.Nominations}/${reviewAndSubmitNominationPageUiStore.currentNomination.nominationId}`,
        { replace: true }
      );
    } catch (error) {
      // TODO - handle error
    }
  };

  const handleClickAddCountry = (): void => {
    onDismissModal();
    redirectToNominationWizardStep('CountrySelection', 'ReviewAndSubmit');
  };

  const handleContinue = (): void => {
    onDismissModal();
    reviewAndSubmitNominationPageUiStore.setShowConfirmationModal(true);
  };

  return (
    <Dialog
      open={isModalOpen}
      onOpenChange={(_, data) => {
        if (!data.open) onDismissModal();
      }}
    >
      <DialogSurface
        className={commonStyles.modalSurface}
      >
        <DialogBody>
          <DialogTitle>
            You have not selected a country
          </DialogTitle>

          <DialogContent>
            <Text
              as='p'
            >
              You will not be submitted for a country award based on your selection. Are you sure you would like to continue?
            </Text>
          </DialogContent>

          <DialogActions>
            <Button
              appearance='secondary'
              onClick={handleClickAddCountry}
            >
              Back to add country
            </Button>
            <Button
              appearance='primary'
              onClick={handleContinue}
            >
              Continue
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export const NoCountrySelectionModal = observer(NoCountrySelectionModalImpl);
